<template>
  <v-content class="pa-12">
    <!-- Nevigater -->
    <v-layout mb-12>
      <v-flex
        shrink
        d-flex
        justify-start
        align-center
        class="nevigater-link"
        @click="$router.push('/sub-meeting')"
      >
        <span>จัดการห้องประชุมย่อย</span>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center>
        <v-icon color="#3E7662">arrow_right</v-icon>
      </v-flex>
      <v-flex
        shrink
        d-flex
        justify-start
        align-center
        style="color: #3E7662;font-weight: bold;font-size: 24px;"
      >
        <span>สร้างการประชุมย่อย</span>
      </v-flex>
    </v-layout>

    <!-- Form -->
    <v-card tile>
      <div style="background-color: #3E7662;padding: 20px">
        <v-switch
          v-model="isAutoSave"
          label="บันทึกอัตโนมัติ"
          dark
          @click="toggleAutoSave()"
        ></v-switch>
      </div>
      <v-divider
        style="background-color: #544A44;border-width: 2px"
      ></v-divider>
      <v-layout px-6 py-2 style="background-color: #FBF6F3">
        <v-flex style="color: #000000;text-align: left;font-weight: bold">
          <span>สร้างการประชุมย่อย</span>
        </v-flex>
        <v-flex style="color: #000000;text-align: right;font-weight: bold">
          <span>RO 11_2563</span>
        </v-flex>
      </v-layout>
      <v-layout px-12 py-6>
        <v-flex>
          <!-- blog 1 -->
          <v-layout>
            <v-flex pr-3 d-flex justify-end align-center xs3>
              <span style="font-weight: bold;">ชื่อการประชุม</span>
            </v-flex>
            <v-flex xs6 d-flex justify-start align-center>
              <textfield-form
                :model="form.meetingName"
                hide-detail
                @update-data="updateData('meetingName', $event)"
              />
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>

          <!-- blog 2 -->
          <v-layout mt-8>
            <v-flex pr-3 d-flex justify-end align-center xs3>
              <span style="font-weight: bold;">การประชุมครั้งที่</span>
            </v-flex>
            <v-flex xs6 d-flex justify-start align-center>
              <v-layout>
                <v-flex mr-4 xs6 d-flex justify-start align-center>
                  <textfield-form
                    hide-detail
                    :model="form.meetingNumber"
                    @update-data="updateData('meetingNumber', $event)"
                  />
                </v-flex>
                <v-flex xs6 d-flex justify-end align-center>
                  <v-layout>
                    <v-flex
                      xs2
                      mr-3
                      shrink
                      d-flex
                      justify-end
                      align-center
                      style="color: black;font-weight: bold;"
                    >
                      <span><b>ปี</b></span>
                    </v-flex>
                    <v-flex d-flex align-center>
                      <v-select
                        class="style-chooser"
                        placeholder="Choose Year"
                        style="width: 100%;"
                        :options="years"
                        v-model="form.meetingYear"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>

          <!-- blog 3 -->
          <v-layout mt-8>
            <v-flex pr-3 d-flex justify-end align-center xs3>
              <span style="font-weight: bold;">วันที่</span>
            </v-flex>
            <v-flex xs6 d-flex justify-start align-center>
              <v-layout>
                <v-flex mr-4 xs6 d-flex justify-start align-center>
                  <DateInputForm
                    hide-detail
                    :model="meetingDate"
                    :picker="form.meetingDate"
                    @update-data="updateDate('meetingDate', $event)"
                  />
                </v-flex>
                <v-flex xs6 shrink d-flex justify-end align-center>
                  <v-layout>
                    <v-flex
                      xs2
                      mr-3
                      d-flex
                      justify-end
                      align-center
                      style="color: black;font-weight: bold;"
                    >
                      <span><b>เวลา</b></span>
                    </v-flex>
                    <v-flex shrink d-flex justify-start align-center>
                      <vue-timepicker
                        v-model="form.meetingTime"
                      ></vue-timepicker>
                    </v-flex>
                    <v-flex shrink d-flex align-center ml-2
                      ><span><b>น.</b></span></v-flex
                    >
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-spacer></v-spacer>
          </v-layout>

          <v-layout mb-6 mt-6 px-12>
            <v-flex
              shrink
              pr-4
              style="text-align: left;"
              class="d-flex align-center"
            >
              <span style="font-weight: bold;font-size: 16px;">
                ผู้เข้าร่วมการประชุมย่อย</span
              >
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink style="text-align: left;">
              <v-btn
                dark
                style="width: 80px;background-color: #3E7662"
                @click="addReviewer('reviewers', 1)"
              >
                <v-icon>add</v-icon>
                <span class="font-weight-bold">เพิ่ม</span>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <div
                v-for="(reviewer, reviewerIndex) in reviewers"
                :key="'reviewer_' + reviewerIndex"
              >
                <v-layout my-1 px-12>
                  <v-flex
                    shrink
                    ml-6
                    mr-4
                    pt-2
                    class="text-end font-weight-bold"
                  >
                    <span>คนที่ {{ reviewerIndex + 1 }}.</span>
                  </v-flex>
                  <v-flex xs5 class="field-select">
                    <text-autocomplete
                      id="reviewer"
                      placeholder="เลือก ชื่อผู้เข้าร่วมประชุม"
                      :items="reviewerList"
                      item-text="user_name"
                      item-value="user_id"
                      :model="reviewer.userID"
                      @update-data="
                        updateData('reviewer', $event, reviewerIndex)
                      "
                    />
                  </v-flex>
                  <v-flex ml-6 class="justify-end" style="text-align: right">
                    <v-btn
                      dark
                      style="background-color: #CC3D45; width: 80px"
                      @click="removeReviewer('reviewers', reviewerIndex)"
                      :disabled="reviewers.length <= 1"
                    >
                      <v-icon>remove</v-icon>
                      <span class="font-weight-bold">ลบ</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>

          <v-layout mb-6 mt-6 px-12>
            <v-flex
              shrink
              pr-4
              style="text-align: left;"
              class="d-flex align-center"
            >
              <span style="font-weight: bold;font-size: 16px;">
                ผู้ไม่ได้เข้าประชุมเนื่องจากติดราชการ</span
              >
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink style="text-align: left;">
              <v-btn
                dark
                style="width: 80px;background-color: #3E7662"
                @click="addReviewer('reviewersNotJoin', 1)"
              >
                <v-icon>add</v-icon>
                <span class="font-weight-bold">เพิ่ม</span>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <div v-for="(input, k) in reviewersNotJoin" :key="k">
                <v-layout my-1 px-12>
                  <v-flex
                    shrink
                    ml-6
                    mr-4
                    pt-2
                    class="text-end font-weight-bold"
                  >
                    <span>คนที่ {{ k + 1 }}.</span>
                  </v-flex>
                  <v-flex xs5 class="field-select">
                    <text-autocomplete
                      id="notJoinReviewer"
                      placeholder="เลือก ชื่อผู้เข้าร่วมประชุม"
                      :items="reviewerList"
                      item-text="user_name"
                      item-value="user_id"
                      :model="input.userID"
                      @update-data="updateData('reviewersNotJoin', $event, k)"
                    />
                  </v-flex>
                  <v-flex ml-6 class="justify-end" style="text-align: right">
                    <v-btn
                      dark
                      style="background-color: #CC3D45; width: 80px"
                      @click="removeReviewer('reviewersNotJoin', k)"
                    >
                      <v-icon>remove</v-icon>
                      <span class="font-weight-bold">ลบ</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>

          <!-- blog 4 -->
          <v-layout mt-6 px-12>
            <v-flex mb-2 style="text-align: left;">
              <span style="font-weight: bold;">
                สถานที่
              </span>
            </v-flex>
          </v-layout>
          <v-layout px-12>
            <v-flex>
              <textarea-form
                :rows="2"
                :model="form.meetingPlace"
                @update-data="updateData('meetingPlace', $event)"
              ></textarea-form>
            </v-flex>
          </v-layout>

          <!--1 agenda-->
          <v-layout px-12>
            <v-flex xs1 mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">
                วาระที่ 1
              </span>
            </v-flex>
            <v-flex mb-2 style="text-align: left;">
              <span style="font-weight: bold;">
                เรื่องแจ้ง โดยประธานคณะทำงาน
              </span>
            </v-flex>
            <v-flex
              shrink
              pt-2
              pr-4
              style="text-align: left;"
              class="justify-end d-flex"
            >
              <span style="font-weight: bold;font-size: 16px;">ไฟล์</span>
            </v-flex>
            <v-flex xs3>
              <v-file-input
                accept=".pdf"
                prepend-icon=""
                outlined
                id="firstAgendaFile"
                dense
                placeholder="Choose file"
                color="#3E7662"
                item-color="#3E7662"
                hide-details
                @change="onUploadFile('firstAgendaFile', 0, $event)"
              ></v-file-input>
            </v-flex>
            <v-flex shrink pl-4 style="text-align: left">
              <v-btn
                color="#3E7662"
                dark
                @click="onHandleBtn('firstAgendaFile')"
              >
                <v-icon class="pr-3">cloud_download</v-icon>
                <span>Upload</span>
              </v-btn>
              <v-btn
                v-if="form.firstAgendaFilePath"
                :href="form.firstAgendaFilePath"
                class="white--text ml-2"
                color="#DE7133"
                target="_blank"
              >
                <span class="text-capitalize">ดาวน์โหลด</span>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout px-12 mt-4>
            <v-flex>
              <textarea-form
                :model="form.firstAgenda"
                @update-data="updateData('firstAgenda', $event)"
              ></textarea-form>
            </v-flex>
          </v-layout>
          <v-layout px-12>
            <p class="meeting-result">มติที่ประชุม</p>
            <v-radio-group row v-model="form.result1">
              <v-radio
                value="รับทราบ"
                label="รับทราบ"
                color="#3E7662"
              ></v-radio>
              <v-radio
                value="ไม่รับทราบ"
                label="ไม่รับทราบ"
                color="#3E7662"
              ></v-radio>
            </v-radio-group>
          </v-layout>

          <!--2 agenda-->
          <v-layout px-12>
            <v-flex xs1 mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">
                วาระที่ 2
              </span>
            </v-flex>
            <v-flex mb-2 style="text-align: left;">
              <span style="font-weight: bold;">
                การมีผลประโยชน์ทับซ้อน (Conflict of interest)
              </span>
            </v-flex>
            <v-flex
              shrink
              pt-2
              pr-4
              style="text-align: left;"
              class="justify-end d-flex"
            >
              <span style="font-weight: bold;font-size: 16px;">ไฟล์</span>
            </v-flex>
            <v-flex xs3>
              <v-file-input
                accept=".pdf"
                prepend-icon=""
                outlined
                id="firstAgendaFile"
                dense
                placeholder="Choose file"
                color="#3E7662"
                item-color="#3E7662"
                hide-details
                @change="onUploadFile('secondAgendaFile', 0, $event)"
              ></v-file-input>
            </v-flex>
            <v-flex shrink pl-4 style="text-align: left">
              <v-btn
                color="#3E7662"
                dark
                @click="onHandleBtn('secondAgendaFile')"
              >
                <v-icon class="pr-3">cloud_download</v-icon>
                <span>Upload</span>
              </v-btn>
              <v-btn
                v-if="form.secondAgendaFilePath"
                :href="form.secondAgendaFilePath"
                class="white--text ml-2"
                color="#DE7133"
                target="_blank"
              >
                <span class="text-capitalize">ดาวน์โหลด</span>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout px-12 mt-4>
            <v-flex>
              <textarea-form
                :model="form.secondAgenda"
                @update-data="updateData('secondAgenda', $event)"
              ></textarea-form>
            </v-flex>
          </v-layout>
          <v-layout px-12>
            <p class="meeting-result">มติที่ประชุม</p>
            <v-radio-group row v-model="form.result2">
              <v-radio
                value="รับทราบ"
                label="รับทราบ"
                color="#3E7662"
              ></v-radio>
              <v-radio
                value="ไม่รับทราบ"
                label="ไม่รับทราบ"
                color="#3E7662"
              ></v-radio>
            </v-radio-group>
          </v-layout>

          <!--3 agenda-->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">วาระที่ 3 </span>
              <span style="font-weight: bold;"
                >เรื่องสืบเนื่องจากการประชุมครั้งที่ผ่านมา</span
              >
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex style="text-align: right" v-if="form.hasAgenda3 === '1'">
              <v-btn color="#3E7662" dark @click="add('agenda3')">
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex ml-12 justify-start align-center d-flex>
              <v-radio-group hide-details v-model="form.hasAgenda3" row>
                <v-radio
                  color="#3E7662"
                  style="padding-right: 60px"
                  label="มี"
                  value="1"
                ></v-radio>
                <v-radio
                  @click.native="clearRadio('hasAgenda3')"
                  color="#3E7662"
                  label="ไม่มี"
                  value="0"
                ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <div v-if="form.hasAgenda3 === '1'">
            <div v-for="(item, Index) in agenda3" :key="'3_' + Index">
              <v-layout class="mx-12 my-8">
                <v-flex xs4>
                  <text-autocomplete
                    clearable
                    hide-details
                    :model="item.meetingID"
                    :items="meetingList"
                    item-text="name"
                    label="รอบการประชุม"
                    item-value="id"
                    @update-data="item.meetingID = $event"
                  />
                </v-flex>
                <v-flex xs1 class="text-right ml-2">
                  <v-btn color="#3E7662" dark @click="add('doc3', Index)">
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex xs7></v-flex>
                <v-flex xs1>
                  <div class="text-end">
                    <v-btn
                      :disabled="agenda3.length <= 1"
                      color="#CC3D45"
                      dark
                      @click="remove(Index, 'agenda3')"
                    >
                      <v-icon>remove</v-icon>
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
              <v-card
                v-for="(con, conIndex) in item.document"
                :key="'con_' + conIndex"
                class="mx-12 mt-4"
              >
                <div class="text-end">
                  <v-icon
                    :disabled="item.document.length <= 1"
                    color="#CC3D45"
                    class="clear-card"
                    @click="remove(conIndex, 'doc3', Index)"
                  >
                    clear
                  </v-icon>
                </div>

                <v-layout px-12>
                  <v-flex xs6 class="justify-start align-center d-flex">
                  </v-flex>
                  <v-flex xs6 class="justify-start align-center d-flex">
                    <v-layout>
                      <text-autocomplete
                        clearable
                        hide-details
                        :model="con.rfType"
                        :items="items"
                        item-text="name"
                        label="ประเภทเอกสาร"
                        item-value="id"
                        :key="renderKey"
                        @update-data="
                          updateData3('rfType', conIndex, $event, Index)
                        "
                      />
                    </v-layout>
                  </v-flex>
                </v-layout>

                <v-layout my-5 px-12>
                  <v-spacer></v-spacer>
                  <v-flex shrink pr-3>
                    <v-layout>
                      <v-flex
                        shrink
                        mr-3
                        class="justify-end align-center d-flex"
                      >
                        <span style="color: #CC3D45;font-weight: bold"
                          >*ระบุหัวข้อการวิจัย</span
                        >
                      </v-flex>
                      <text-autocomplete
                        clearable
                        :disabled="
                          con.rfType === '' || con.rfType === 'undefined'
                        "
                        :items="researchConList[Index * 10 + conIndex]"
                        hide-details
                        item-text="name"
                        item-value="id"
                        :model="con.researchID"
                        @update-data="
                          updateData3('researchID', conIndex, $event, Index)
                        "
                      />
                    </v-layout>
                  </v-flex>
                  <v-flex shrink class="justify-end align-center d-flex">
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold;font-size: 16px;"
                          >ไฟล์</span
                        >
                      </v-flex>
                      <v-flex>
                        <v-file-input
                          :disabled="
                            con.rfType === '' || con.rfType === 'undefined'
                          "
                          accept=".pdf"
                          prepend-icon=""
                          :ref="'continueFile_' + conIndex"
                          :model="con.file"
                          outlined
                          dense
                          placeholder="Choose file"
                          :background-color="
                            con.rfType === '' || con.rfType === 'undefined'
                              ? '#E9E9E9'
                              : '#FBF6F3'
                          "
                          color="#3E7662"
                          item-color="#3E7662"
                          @change="
                            onUploadFile('agenda3', conIndex, $event, Index)
                          "
                          hide-details
                        ></v-file-input>
                      </v-flex>
                      <v-flex shrink pl-4 style="text-align: left">
                        <v-btn
                          v-if="con.filePath"
                          :href="con.filePath"
                          class="white--text ml-2"
                          color="#DE7133"
                          target="_blank"
                        >
                          <span>ดาวน์โหลด</span>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <v-layout mt-4 px-12>
                  <v-flex>
                    <textarea-form
                      background-color="#FBF6F3"
                      :rows="7"
                      :model="con.description"
                      @update-data="
                        updateData3('description', conIndex, $event, Index)
                      "
                    ></textarea-form>
                  </v-flex>
                </v-layout>

                <v-layout px-12 pb-12 v-if="con.researchID">
                  <v-flex shrink mr-3 class="justify-end align-center d-flex">
                    <span style="color: #CC3D45;font-weight: bold"
                      >ผู้รับผิดชอบ</span
                    >
                  </v-flex>
                  <v-flex xs4 class="justify-end align-center d-flex ">
                    <textfield-form
                      readonly
                      hide-detail
                      :model="con.reviewerName"
                    />
                  </v-flex>
                </v-layout>
              </v-card>
            </div>
          </div>
          <v-layout pa-12 v-if="form.hasAgenda3 === '1'">
            <p class="meeting-result">มติที่ประชุม</p>
            <v-radio-group row v-model="form.result3">
              <v-radio
                value="รับทราบข้อชี้แจง"
                label="รับทราบข้อชี้แจง"
                color="#3E7662"
              ></v-radio>
              <v-radio
                value="รอการชี้แจงจากผู้วิจัย"
                label="รอการชี้แจงจากผู้วิจัย"
                color="#3E7662"
              ></v-radio>
            </v-radio-group>
          </v-layout>

          <!-- 4_1 agenda-->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">วาระที่ 4 </span>
              <span style="font-weight: bold;"
                >การประเมินต่อเนื่องโครงการวิจัย
              </span>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">วาระที่ 4.1 </span>
              <span style="font-weight: bold;"
                >รายงานส่วนแก้ไขเพิ่มเติมโครงร่างการวิจัย (Protocol
                amendment)</span
              >
            </v-flex>
            <v-flex shrink ml-4 v-if="form.hasAgenda4_1 === '1'">
              <p>จำนวน {{ agenda4_1.length }} โครงการ</p>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex style="text-align: right" v-if="form.hasAgenda4_1 === '1'">
              <v-btn color="#3E7662" dark @click="add('agenda4_1')">
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex ml-12 justify-start align-center d-flex>
              <v-radio-group hide-details v-model="form.hasAgenda4_1" row>
                <v-radio
                  color="#3E7662"
                  style="padding-right: 60px"
                  label="มี"
                  value="1"
                ></v-radio>
                <v-radio
                  @click.native="clearRadio('hasAgenda4_1', k)"
                  color="#3E7662"
                  label="ไม่มี"
                  value="0"
                ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <div v-if="form.hasAgenda4_1 === '1'">
            <v-card
              class="mx-12 mt-4"
              v-for="(amendment, amendmentIndex) in agenda4_1"
              :key="'4_1_' + amendmentIndex"
            >
              <div class="text-end">
                <v-icon
                  :disabled="agenda4_1.length <= 1"
                  color="#CC3D45"
                  class="clear-card"
                  @click="remove(amendmentIndex, 'agenda4_1')"
                >
                  clear
                </v-icon>
              </div>

              <v-layout px-12>
                <v-flex ml-12 class="justify-start align-center d-flex">
                </v-flex>
                <v-flex shrink mr-3 class="justify-end align-center d-flex">
                  <span style="color: #CC3D45;font-weight: bold"
                    >*ระบุหัวข้อการวิจัย</span
                  >
                </v-flex>
                <v-flex xs4 class="justify-end align-center d-flex">
                  <text-autocomplete
                    :items="researchAmendmentsList"
                    hide-details
                    item-text="name"
                    item-value="id"
                    :model="amendment.researchID"
                    @update-data="
                      updateData4_1('researchID', amendmentIndex, $event)
                    "
                  />
                </v-flex>
              </v-layout>

              <!-- <pre class="warning">{{ agenda4_1 }}</pre> -->

              <v-layout px-12 my-6>
                <v-spacer></v-spacer>
                <v-flex>
                  <v-layout>
                    <v-flex
                      xs4
                      pt-2
                      pr-4
                      style="text-align: left;"
                      class="justify-end d-flex"
                    >
                      <span style="font-weight: bold;font-size: 16px;"
                        >ไฟล์</span
                      >
                    </v-flex>
                    <v-flex>
                      <v-file-input
                        accept=".pdf"
                        prepend-icon=""
                        :ref="'amendmentFile_' + amendmentIndex"
                        :id="'amendmentFile_' + amendmentIndex"
                        :model="amendment.file"
                        outlined
                        dense
                        counter
                        placeholder="Choose file"
                        :background-color="
                          amendment.has === '0' ||
                          amendment.rfType === '' ||
                          amendment.rfType === 'undefined'
                            ? '#E9E9E9'
                            : '#FBF6F3'
                        "
                        color="#3E7662"
                        item-color="#3E7662"
                        @change="
                          onUploadFile('agenda4_1', amendmentIndex, $event)
                        "
                        hide-details
                      >
                      </v-file-input>
                    </v-flex>
                    <v-flex shrink pl-4 style="text-align: left">
                      <v-btn
                        color="#3E7662"
                        dark
                        @click="onHandleBtn('amendmentFile_' + amendmentIndex)"
                      >
                        <v-icon class="pr-3">cloud_download</v-icon>
                        <span>Upload</span>
                      </v-btn>
                      <v-btn
                        v-if="amendment.filePath"
                        :href="amendment.filePath"
                        class="white--text ml-2"
                        color="#DE7133"
                        target="_blank"
                      >
                        <span>ดาวน์โหลด</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout mt-4 px-12>
                <v-flex>
                  <textarea-form
                    :disabled="amendment.has === '0'"
                    :background-color="
                      amendment.has === '0' ? '#E9E9E9' : '#FBF6F3'
                    "
                    :rows="7"
                    :model="amendment.description"
                    @update-data="
                      updateData4_1('description', amendmentIndex, $event)
                    "
                  ></textarea-form>
                </v-flex>
              </v-layout>

              <div v-if="amendment.researchID">
                <v-layout mb-6 mt-6 px-12>
                  <v-flex
                    shrink
                    pr-4
                    style="text-align: left;"
                    class="d-flex align-center"
                  >
                    <span style="font-weight: bold;font-size: 16px;">
                      เลือกผู้ประเมิน</span
                    >
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex shrink style="text-align: left;">
                    <v-btn
                      dark
                      style="width: 80px;background-color: #3E7662"
                      @click="addReviewer('reviewers4_1', amendmentIndex)"
                    >
                      <v-icon>add</v-icon>
                      <span class="font-weight-bold">เพิ่ม</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <div
                      v-for="(reviewers4_1,
                      reviewers4_1Index) in amendment.reviewers"
                      :key="'reviewers4_1_' + reviewers4_1Index"
                    >
                      <v-layout my-1 px-12>
                        <v-flex
                          shrink
                          ml-6
                          mr-4
                          pt-2
                          class="text-end font-weight-bold"
                        >
                          <span>คนที่ {{ reviewers4_1Index + 1 }}.</span>
                        </v-flex>
                        <v-flex xs5 class="field-select">
                          <text-autocomplete
                            id="reviewers4_1"
                            placeholder="เลือก ผู้ประเมิน"
                            :items="reviewerList"
                            item-text="user_name"
                            item-value="user_id"
                            :model="reviewers4_1.userID"
                            @update-data="
                              updateData(
                                'reviewers4_1',
                                $event,
                                reviewers4_1Index,
                                amendmentIndex
                              )
                            "
                          />
                        </v-flex>
                        <v-flex
                          ml-6
                          class="justify-end"
                          style="text-align: right"
                        >
                          <v-btn
                            dark
                            style="background-color: #CC3D45; width: 80px"
                            @click="
                              removeReviewer(
                                'reviewers4_1',
                                reviewers4_1Index,
                                amendmentIndex
                              )
                            "
                            :disabled="amendment.reviewers.length <= 1"
                          >
                            <v-icon>remove</v-icon>
                            <span class="font-weight-bold">ลบ</span>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                      <v-layout my-1 px-6>
                        <v-flex>
                          <textarea-form
                            placeholder="ข้อคิดเห็นจากผู้รับผิดชอบ"
                            background-color="#FBF6F3"
                            :rows="7"
                            :model="reviewers4_1.comment"
                            readonly
                          ></textarea-form>
                        </v-flex>
                      </v-layout>
                      <v-layout pb-6>
                        <v-flex class="text-right mr-12">
                          <v-btn
                            v-if="reviewers4_1.filePath"
                            :href="reviewers4_1.filePath"
                            class="white--text ml-2"
                            color="#DE7133"
                            target="_blank"
                          >
                            <span class="text-capitalize">ดาวน์โหลด</span>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </v-card>
          </div>
          <v-layout pa-12 v-if="form.hasAgenda4_1 === '1'">
            <p class="meeting-result">มติที่ประชุม</p>
            <v-radio-group row v-model="form.result4_1">
              <v-radio
                value="รับทราบ"
                label="รับทราบ"
                color="#3E7662"
              ></v-radio>
              <v-radio value="รับรอง" label="รับรอง" color="#3E7662"></v-radio>
            </v-radio-group>
          </v-layout>

          <!-- 4_2_1 agenda -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">วาระที่ 4.2 </span>
              <span style="font-weight: bold;"
                >รายงานความปลอดภัย (Safety report)
              </span>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662"
                >วาระที่ 4.2.1
              </span>
              <span style="font-weight: bold;"
                >รายงานรวบรวมเหตุการณ์ไม่พึงประสงค์นอกสถาบัน</span
              >
            </v-flex>
            <v-flex shrink ml-4 v-if="form.hasAgenda4_2_1 === '1'">
              <p>จำนวน {{ agenda4_2_1.length }} โครงการ</p>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex
              style="text-align: right"
              v-if="form.hasAgenda4_2_1 === '1'"
            >
              <v-btn color="#3E7662" dark @click="add('agenda4_2_1')">
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex ml-12 justify-start align-center d-flex>
              <v-radio-group hide-details v-model="form.hasAgenda4_2_1" row>
                <v-radio
                  color="#3E7662"
                  style="padding-right: 60px"
                  label="มี"
                  value="1"
                ></v-radio>
                <v-radio
                  @click.native="clearRadio('hasAgenda4_2_1', k)"
                  color="#3E7662"
                  label="ไม่มี"
                  value="0"
                ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <div v-if="form.hasAgenda4_2_1 === '1'">
            <v-card
              v-for="(con, conIndex) in agenda4_2_1"
              :key="'4_2_1_' + conIndex"
              class="mx-12 mt-4"
            >
              <div class="text-end">
                <v-icon
                  :disabled="agenda4_2_1.length <= 1"
                  color="#CC3D45"
                  class="clear-card"
                  @click="remove(conIndex, 'agenda4_2_1')"
                >
                  clear
                </v-icon>
              </div>

              <v-layout px-12>
                <v-flex xs6 class="justify-start align-center d-flex"> </v-flex>
                <v-flex xs6 class="justify-start align-center d-flex">
                  <v-layout>
                    <text-autocomplete
                      clearable
                      hide-details
                      :model="con.rfType"
                      :items="adverseItems"
                      item-text="name"
                      label="ประเภทเอกสาร"
                      item-value="id"
                      @update-data="updateData4_2_1('rfType', conIndex, $event)"
                    />
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout my-5 px-12>
                <v-spacer></v-spacer>
                <v-flex shrink pr-3>
                  <v-layout>
                    <v-flex shrink mr-3 class="justify-end align-center d-flex">
                      <span style="color: #CC3D45;font-weight: bold"
                        >*ระบุหัวข้อการวิจัย</span
                      >
                    </v-flex>
                    <text-autocomplete
                      clearable
                      :disabled="
                        con.rfType === '' || con.rfType === 'undefined'
                      "
                      :items="research4_2_1List[conIndex]"
                      hide-details
                      item-text="name"
                      item-value="id"
                      :model="con.researchID"
                      @update-data="
                        updateData4_2_1('researchID', conIndex, $event)
                      "
                    />
                  </v-layout>
                </v-flex>
                <v-flex shrink class="justify-end align-center d-flex">
                  <v-layout>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 16px;"
                        >ไฟล์</span
                      >
                    </v-flex>
                    <v-flex>
                      <v-file-input
                        :disabled="
                          con.rfType === '' || con.rfType === 'undefined'
                        "
                        accept=".pdf"
                        prepend-icon=""
                        :ref="'4_2_1_' + conIndex"
                        :model="con.file"
                        outlined
                        dense
                        placeholder="Choose file"
                        :background-color="
                          con.rfType === '' || con.rfType === 'undefined'
                            ? '#E9E9E9'
                            : '#FBF6F3'
                        "
                        color="#3E7662"
                        item-color="#3E7662"
                        @change="onUploadFile('agenda4_2_1', conIndex, $event)"
                        hide-details
                      ></v-file-input>
                    </v-flex>
                    <v-flex shrink pl-4 style="text-align: left">
                      <!--                      <v-btn color="#3E7662" dark @click="onHandleBtn('continue', 'file_'+conIndex)">-->
                      <!--                        <v-icon class="pr-3">cloud_download</v-icon>-->
                      <!--                        <span>Upload</span>-->
                      <!--                      </v-btn>-->
                      <v-btn
                        v-if="con.filePath"
                        :href="con.filePath"
                        class="white--text ml-2"
                        color="#DE7133"
                        target="_blank"
                      >
                        <span>ดาวน์โหลด</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout mt-4 px-12>
                <v-flex>
                  <textarea-form
                    background-color="#FBF6F3"
                    :rows="7"
                    :model="con.description"
                    @update-data="
                      updateData4_2_1('description', conIndex, $event)
                    "
                  ></textarea-form>
                </v-flex>
              </v-layout>

              <v-layout px-12 pb-12 v-if="con.researchID">
                <v-flex shrink mr-3 class="justify-end align-center d-flex">
                  <span style="color: #CC3D45;font-weight: bold"
                    >ผู้รับผิดชอบ</span
                  >
                </v-flex>
                <v-flex xs4 class="justify-end align-center d-flex ">
                  <textfield-form
                    readonly
                    hide-detail
                    :model="con.reviewerName"
                  />
                </v-flex>
              </v-layout>
            </v-card>
          </div>
          <v-layout pa-12 v-if="form.hasAgenda4_2_1 === '1'">
            <p class="meeting-result">มติที่ประชุม</p>
            <v-radio-group row v-model="form.result4_2_1">
              <v-radio
                value="รับทราบ"
                label="รับทราบ"
                color="#3E7662"
              ></v-radio>
              <v-radio
                value="ไม่รับทราบ"
                label="ไม่รับทราบ"
                color="#3E7662"
              ></v-radio>
            </v-radio-group>
          </v-layout>

          <!-- 4_2_2 agenda -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662"
                >วาระที่ 4.2.2
              </span>
              <span style="font-weight: bold;"
                >รายงานรวบรวมเหตุการณ์ไม่พึงประสงค์ในสถาบัน</span
              >
            </v-flex>
            <v-flex shrink ml-4 v-if="form.hasAgenda4_2_2 === '1'">
              <p>จำนวน {{ agenda4_2_2.length }} โครงการ</p>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex
              style="text-align: right"
              v-if="form.hasAgenda4_2_2 === '1'"
            >
              <v-btn color="#3E7662" dark @click="add('agenda4_2_2')">
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex ml-12 justify-start align-center d-flex>
              <v-radio-group hide-details v-model="form.hasAgenda4_2_2" row>
                <v-radio
                  color="#3E7662"
                  style="padding-right: 60px"
                  label="มี"
                  value="1"
                ></v-radio>
                <v-radio
                  @click.native="clearRadio('hasAgenda4_2_2', k)"
                  color="#3E7662"
                  label="ไม่มี"
                  value="0"
                ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <div v-if="form.hasAgenda4_2_2 === '1'">
            <v-card
              v-for="(con, conIndex) in agenda4_2_2"
              :key="'4_2_2_' + conIndex"
              class="mx-12 mt-4"
            >
              <div class="text-end">
                <v-icon
                  :disabled="agenda4_2_2.length <= 1"
                  color="#CC3D45"
                  class="clear-card"
                  @click="remove(conIndex, 'agenda4_2_2')"
                >
                  clear
                </v-icon>
              </div>

              <v-layout px-12>
                <v-flex xs6 class="justify-start align-center d-flex"> </v-flex>
                <v-flex xs6 class="justify-start align-center d-flex">
                  <v-layout>
                    <text-autocomplete
                      clearable
                      hide-details
                      :model="con.rfType"
                      :items="adverseItems"
                      item-text="name"
                      label="ประเภทเอกสาร"
                      item-value="id"
                      @update-data="updateData4_2_2('rfType', conIndex, $event)"
                    />
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout my-5 px-12>
                <v-spacer></v-spacer>
                <v-flex shrink pr-3>
                  <v-layout>
                    <v-flex shrink mr-3 class="justify-end align-center d-flex">
                      <span style="color: #CC3D45;font-weight: bold"
                        >*ระบุหัวข้อการวิจัย</span
                      >
                    </v-flex>
                    <text-autocomplete
                      clearable
                      :disabled="
                        con.rfType === '' || con.rfType === 'undefined'
                      "
                      :items="research4_2_2List[conIndex]"
                      hide-details
                      item-text="name"
                      item-value="id"
                      :model="con.researchID"
                      @update-data="
                        updateData4_2_2('researchID', conIndex, $event)
                      "
                    />
                  </v-layout>
                </v-flex>
                <v-flex shrink class="justify-end align-center d-flex">
                  <v-layout>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 16px;"
                        >ไฟล์</span
                      >
                    </v-flex>
                    <v-flex>
                      <v-file-input
                        :disabled="
                          con.rfType === '' || con.rfType === 'undefined'
                        "
                        accept=".pdf"
                        prepend-icon=""
                        :ref="'4_2_2_' + conIndex"
                        :model="con.file"
                        outlined
                        dense
                        placeholder="Choose file"
                        :background-color="
                          con.rfType === '' || con.rfType === 'undefined'
                            ? '#E9E9E9'
                            : '#FBF6F3'
                        "
                        color="#3E7662"
                        item-color="#3E7662"
                        @change="onUploadFile('agenda4_2_2', conIndex, $event)"
                        hide-details
                      ></v-file-input>
                    </v-flex>
                    <v-flex shrink pl-4 style="text-align: left">
                      <!--                      <v-btn color="#3E7662" dark @click="onHandleBtn('continue', 'file_'+conIndex)">-->
                      <!--                        <v-icon class="pr-3">cloud_download</v-icon>-->
                      <!--                        <span>Upload</span>-->
                      <!--                      </v-btn>-->
                      <v-btn
                        v-if="con.filePath"
                        :href="con.filePath"
                        class="white--text ml-2"
                        color="#DE7133"
                        target="_blank"
                      >
                        <span>ดาวน์โหลด</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout mt-4 px-12>
                <v-flex>
                  <textarea-form
                    background-color="#FBF6F3"
                    :rows="7"
                    :model="con.description"
                    @update-data="
                      updateData4_2_2('description', conIndex, $event)
                    "
                  ></textarea-form>
                </v-flex>
              </v-layout>

              <v-layout px-12 pb-12 v-if="con.researchID">
                <v-flex shrink mr-3 class="justify-end align-center d-flex">
                  <span style="color: #CC3D45;font-weight: bold"
                    >ผู้รับผิดชอบ</span
                  >
                </v-flex>
                <v-flex xs4 class="justify-end align-center d-flex ">
                  <textfield-form
                    readonly
                    hide-detail
                    :model="con.reviewerName"
                  />
                </v-flex>
              </v-layout>
            </v-card>
          </div>
          <v-layout pa-12 v-if="form.hasAgenda4_2_2 === '1'">
            <p class="meeting-result">มติที่ประชุม</p>
            <v-radio-group row v-model="form.result4_2_2">
              <v-radio
                value="รับทราบ"
                label="รับทราบ"
                color="#3E7662"
              ></v-radio>
              <v-radio
                value="ไม่รับทราบ"
                label="ไม่รับทราบ"
                color="#3E7662"
              ></v-radio>
            </v-radio-group>
          </v-layout>

          <!-- 4_3 agenda -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">วาระที่ 4.3 </span>
              <span style="font-weight: bold;"
                >รายงานการเบี่ยงเบนหรือไม่ปฏิบัติตามโครงร่างการวิจัยที่ได้รับการรับรอง
                (Protocol deviation/violation)</span
              >
            </v-flex>
            <v-flex shrink ml-4 v-if="form.hasAgenda4_3 === '1'">
              <p>จำนวน {{ agenda4_3.length }} โครงการ</p>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex style="text-align: right" v-if="form.hasAgenda4_3 === '1'">
              <v-btn color="#3E7662" dark @click="add('agenda4_3')">
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex ml-12 justify-start align-center d-flex>
              <v-radio-group hide-details v-model="form.hasAgenda4_3" row>
                <v-radio
                  color="#3E7662"
                  style="padding-right: 60px"
                  label="มี"
                  value="1"
                ></v-radio>
                <v-radio
                  @click.native="clearRadio('hasAgenda4_3', k)"
                  color="#3E7662"
                  label="ไม่มี"
                  value="0"
                ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <div v-if="form.hasAgenda4_3 === '1'">
            <v-card
              class="mx-12 mt-4"
              v-for="(deviation, deviationIndex) in agenda4_3"
              :key="'4_3_' + deviationIndex"
            >
              <div class="text-end">
                <v-icon
                  :disabled="agenda4_3.length <= 1"
                  color="#CC3D45"
                  class="clear-card"
                  @click="remove(deviationIndex, 'agenda4_3')"
                >
                  clear
                </v-icon>
              </div>

              <v-layout px-12>
                <v-flex ml-12 class="justify-start align-center d-flex">
                </v-flex>
                <v-flex shrink mr-3 class="justify-end align-center d-flex">
                  <span style="color: #CC3D45;font-weight: bold"
                    >*ระบุหัวข้อการวิจัย</span
                  >
                </v-flex>
                <v-flex xs4 class="justify-end align-center d-flex">
                  <text-autocomplete
                    :items="researchDeviationsList"
                    hide-details
                    item-text="name"
                    item-value="id"
                    :model="deviation.researchID"
                    @update-data="
                      updateData4_3('researchID', deviationIndex, $event)
                    "
                  />
                </v-flex>
              </v-layout>

              <!-- <pre class="warning">{{ agenda4_3 }}</pre> -->

              <v-layout px-12 my-6>
                <v-spacer></v-spacer>
                <v-flex>
                  <v-layout>
                    <v-flex
                      xs4
                      pt-2
                      pr-4
                      style="text-align: left;"
                      class="justify-end d-flex"
                    >
                      <span style="font-weight: bold;font-size: 16px;"
                        >ไฟล์</span
                      >
                    </v-flex>
                    <v-flex>
                      <v-file-input
                        accept=".pdf"
                        prepend-icon=""
                        :ref="'deviationFile_' + deviationIndex"
                        :id="'deviationFile_' + deviationIndex"
                        :model="deviation.file"
                        outlined
                        dense
                        counter
                        placeholder="Choose file"
                        :background-color="
                          deviation.has === '0' ||
                          deviation.rfType === '' ||
                          deviation.rfType === 'undefined'
                            ? '#E9E9E9'
                            : '#FBF6F3'
                        "
                        color="#3E7662"
                        item-color="#3E7662"
                        @change="
                          onUploadFile('agenda4_3', deviationIndex, $event)
                        "
                        hide-details
                      >
                      </v-file-input>
                    </v-flex>
                    <v-flex shrink pl-4 style="text-align: left">
                      <v-btn
                        color="#3E7662"
                        dark
                        @click="onHandleBtn('deviationFile_' + deviationIndex)"
                      >
                        <v-icon class="pr-3">cloud_download</v-icon>
                        <span>Upload</span>
                      </v-btn>
                      <v-btn
                        v-if="deviation.filePath"
                        :href="deviation.filePath"
                        class="white--text ml-2"
                        color="#DE7133"
                        target="_blank"
                      >
                        <span>ดาวน์โหลด</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout mt-4 px-12>
                <v-flex>
                  <textarea-form
                    :disabled="deviation.has === '0'"
                    :background-color="
                      deviation.has === '0' ? '#E9E9E9' : '#FBF6F3'
                    "
                    :rows="7"
                    :model="deviation.description"
                    @update-data="
                      updateData4_3('description', deviationIndex, $event)
                    "
                  ></textarea-form>
                </v-flex>
              </v-layout>

              <v-layout px-12 pb-12 v-if="deviation.researchID">
                <v-flex shrink mr-3 class="justify-end align-center d-flex">
                  <span style="color: #CC3D45;font-weight: bold"
                    >ผู้รับผิดชอบ</span
                  >
                </v-flex>
                <v-flex xs4 class="justify-end align-center d-flex ">
                  <textfield-form
                    readonly
                    hide-detail
                    :model="deviation.reviewerName"
                  />
                </v-flex>
              </v-layout>
            </v-card>
          </div>
          <v-layout pa-12 v-if="form.hasAgenda4_3 === '1'">
            <p class="meeting-result">มติที่ประชุม</p>
            <v-radio-group row v-model="form.result4_3">
              <v-radio
                value="รับทราบ"
                label="รับทราบ"
                color="#3E7662"
              ></v-radio>
              <v-radio
                value="ไม่รับทราบ"
                label="ไม่รับทราบ"
                color="#3E7662"
              ></v-radio>
            </v-radio-group>
          </v-layout>

          <!-- 4.4 genda -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">วาระที่ 4.4 </span>
              <span style="font-weight: bold;"
                >รายงานการความก้าวหน้าและขอต่ออายุโครงการ/แจ้งปิดโครงการวิจัย/ยุติโครงการวิจัยอนกำหนด
                (Progress/Final/Terminate)</span
              >
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662"
                >วาระที่ 4.4.1
              </span>
              <span style="font-weight: bold;">Progress</span>
            </v-flex>
            <v-flex shrink ml-4 v-if="form.hasAgenda4_4_1 === '1'">
              <p>จำนวน {{ agenda4_4_1.length }} โครงการ</p>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex
              style="text-align: right"
              v-if="form.hasAgenda4_4_1 === '1'"
            >
              <v-btn color="#3E7662" dark @click="add('agenda4_4_1')">
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex ml-12 justify-start align-center d-flex>
              <v-radio-group hide-details v-model="form.hasAgenda4_4_1" row>
                <v-radio
                  color="#3E7662"
                  style="padding-right: 60px"
                  label="มี"
                  value="1"
                ></v-radio>
                <v-radio
                  @click.native="clearRadio('hasAgenda4_4_1')"
                  color="#3E7662"
                  label="ไม่มี"
                  value="0"
                ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <!-- 4.4.1 if = 1 -->
          <div v-if="form.hasAgenda4_4_1 === '1'">
            <v-card
              class="mx-12 mt-4"
              v-for="(progress, progressIndex) in agenda4_4_1"
              :key="'4_4_1' + progressIndex"
            >
              <div class="text-end">
                <v-icon
                  :disabled="agenda4_4_1.length <= 1"
                  color="#CC3D45"
                  class="clear-card"
                  @click="remove(progressIndex, 'agenda4_4_1')"
                >
                  clear
                </v-icon>
              </div>

              <v-layout px-12>
                <v-flex ml-12 class="justify-start align-center d-flex">
                </v-flex>
                <v-flex shrink mr-3 class="justify-end align-center d-flex">
                  <span style="color: #CC3D45;font-weight: bold"
                    >*ระบุหัวข้อการวิจัย</span
                  >
                </v-flex>
                <v-flex xs4 class="justify-end align-center d-flex">
                  <text-autocomplete
                    :disabled="progress.has === '0'"
                    :items="progressList"
                    hide-details
                    item-text="name"
                    item-value="id"
                    :model="progress.researchID"
                    @update-data="
                      updateData4_4_1('researchID', progressIndex, $event)
                    "
                  />
                </v-flex>
              </v-layout>

              <v-layout px-12 my-6>
                <v-spacer></v-spacer>
                <v-flex>
                  <v-layout>
                    <v-flex
                      xs4
                      pt-2
                      pr-4
                      style="text-align: left;"
                      class="justify-end d-flex"
                    >
                      <span style="font-weight: bold;font-size: 16px;"
                        >ไฟล์</span
                      >
                    </v-flex>
                    <v-flex>
                      <v-file-input
                        :disabled="progress.has === '0'"
                        accept=".pdf"
                        prepend-icon=""
                        :ref="'progressFile_' + progressIndex"
                        :id="'progressFile_' + progressIndex"
                        :model="progress.file"
                        outlined
                        dense
                        counter
                        placeholder="Choose file"
                        :background-color="
                          progress.has === '0' ||
                          progress.rfType === '' ||
                          progress.rfType === 'undefined'
                            ? '#E9E9E9'
                            : '#FBF6F3'
                        "
                        color="#3E7662"
                        item-color="#3E7662"
                        @change="
                          onUploadFile('agenda4_4_1', progressIndex, $event)
                        "
                        hide-details
                      >
                      </v-file-input>
                    </v-flex>
                    <v-flex shrink pl-4 style="text-align: left">
                      <v-btn
                        :disabled="progress.has === '0'"
                        color="#3E7662"
                        :dark="progress.has !== '0'"
                        @click="onHandleBtn('progressFile_' + progressIndex)"
                      >
                        <v-icon class="pr-3">cloud_download</v-icon>
                        <span>Upload</span>
                      </v-btn>
                    </v-flex>
                    <v-flex shrink pl-4 style="text-align: left">
                      <v-btn
                        v-if="progress.filePath"
                        :href="progress.filePath"
                        class="white--text ml-2"
                        color="#DE7133"
                        target="_blank"
                      >
                        <span class="text-capitalize">ดาวน์โหลด</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout mt-4 px-12>
                <v-flex>
                  <textarea-form
                    :disabled="progress.has === '0'"
                    :background-color="
                      progress.has === '0' ? '#E9E9E9' : '#FBF6F3'
                    "
                    :rows="7"
                    :model="progress.description"
                    @update-data="
                      updateData4_4_1('description', progressIndex, $event)
                    "
                  ></textarea-form>
                </v-flex>
              </v-layout>

              <v-layout px-12 pb-12 v-if="progress.researchID">
                <v-flex shrink mr-3 class="justify-end align-center d-flex">
                  <span style="color: #CC3D45;font-weight: bold"
                    >ผู้รับผิดชอบ</span
                  >
                </v-flex>
                <v-flex xs4 class="justify-end align-center d-flex ">
                  <textfield-form
                    readonly
                    hide-detail
                    :model="progress.reviewerName"
                  />
                </v-flex>
              </v-layout>
            </v-card>
          </div>

          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662"
                >วาระที่ 4.4.2
              </span>
              <span style="font-weight: bold;">Final</span>
            </v-flex>
            <v-flex shrink ml-4 v-if="form.hasAgenda4_4_2 === '1'">
              <p>จำนวน {{ agenda4_4_2.length }} โครงการ</p>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex
              style="text-align: right"
              v-if="form.hasAgenda4_4_2 === '1'"
            >
              <v-btn color="#3E7662" dark @click="add('agenda4_4_2')">
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex ml-12 justify-start align-center d-flex>
              <v-radio-group hide-details v-model="form.hasAgenda4_4_2" row>
                <v-radio
                  color="#3E7662"
                  style="padding-right: 60px"
                  label="มี"
                  value="1"
                ></v-radio>
                <v-radio
                  @click.native="clearRadio('hasAgenda4_4_2')"
                  color="#3E7662"
                  label="ไม่มี"
                  value="0"
                ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <!-- 4.4.2 if = 1  -->
          <div v-if="form.hasAgenda4_4_2 === '1'">
            <v-card
              class="mx-12 mt-4"
              v-for="(final, finalIndex) in agenda4_4_2"
              :key="'4_4_2' + finalIndex"
            >
              <div class="text-end">
                <v-icon
                  :disabled="agenda4_4_2.length <= 1"
                  color="#CC3D45"
                  class="clear-card"
                  @click="remove(finalIndex, 'agenda4_4_2')"
                >
                  clear
                </v-icon>
              </div>

              <v-layout px-12>
                <v-flex ml-12 class="justify-start align-center d-flex">
                </v-flex>
                <v-flex shrink mr-3 class="justify-end align-center d-flex">
                  <span style="color: #CC3D45;font-weight: bold"
                    >*ระบุหัวข้อการวิจัย</span
                  >
                </v-flex>
                <v-flex xs4 class="justify-end align-center d-flex">
                  <text-autocomplete
                    :disabled="final.has === '0'"
                    :items="finalList"
                    hide-details
                    item-text="name"
                    item-value="id"
                    :model="final.researchID"
                    @update-data="
                      updateData4_4_2('researchID', finalIndex, $event)
                    "
                  />
                </v-flex>
              </v-layout>

              <v-layout px-12 my-6>
                <v-spacer></v-spacer>
                <v-flex>
                  <v-layout>
                    <v-flex
                      xs4
                      pt-2
                      pr-4
                      style="text-align: left;"
                      class="justify-end d-flex"
                    >
                      <span style="font-weight: bold;font-size: 16px;"
                        >ไฟล์</span
                      >
                    </v-flex>
                    <v-flex>
                      <v-file-input
                        :disabled="final.has === '0'"
                        accept=".pdf"
                        prepend-icon=""
                        :ref="'finalFile_' + finalIndex"
                        :id="'finalFile_' + finalIndex"
                        :model="final.file"
                        outlined
                        dense
                        counter
                        placeholder="Choose file"
                        :background-color="
                          final.has === '0' ||
                          final.rfType === '' ||
                          final.rfType === 'undefined'
                            ? '#E9E9E9'
                            : '#FBF6F3'
                        "
                        color="#3E7662"
                        item-color="#3E7662"
                        @change="
                          onUploadFile('agenda4_4_2', finalIndex, $event)
                        "
                        hide-details
                      >
                      </v-file-input>
                    </v-flex>
                    <v-flex shrink pl-4 style="text-align: left">
                      <v-btn
                        :disabled="final.has === '0'"
                        color="#3E7662"
                        :dark="final.has !== '0'"
                        @click="onHandleBtn('finalFile_' + finalIndex)"
                      >
                        <v-icon class="pr-3">cloud_download</v-icon>
                        <span>Upload</span>
                      </v-btn>
                    </v-flex>
                    <v-flex shrink pl-4 style="text-align: left">
                      <v-btn
                        v-if="final.filePath"
                        :href="final.filePath"
                        class="white--text ml-2"
                        color="#DE7133"
                        target="_blank"
                      >
                        <span class="text-capitalize">ดาวน์โหลด</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout mt-4 px-12>
                <v-flex>
                  <textarea-form
                    :disabled="final.has === '0'"
                    :background-color="
                      final.has === '0' ? '#E9E9E9' : '#FBF6F3'
                    "
                    :rows="7"
                    :model="final.description"
                    @update-data="
                      updateData4_4_2('description', finalIndex, $event)
                    "
                  ></textarea-form>
                </v-flex>
              </v-layout>

              <v-layout px-12 pb-12 v-if="final.researchID">
                <v-flex shrink mr-3 class="justify-end align-center d-flex">
                  <span style="color: #CC3D45;font-weight: bold"
                    >ผู้รับผิดชอบ</span
                  >
                </v-flex>
                <v-flex xs4 class="justify-end align-center d-flex ">
                  <textfield-form
                    readonly
                    hide-detail
                    :model="final.reviewerName"
                  />
                </v-flex>
              </v-layout>
            </v-card>
          </div>

          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662"
                >วาระที่ 4.4.3
              </span>
              <span style="font-weight: bold;">Terminate</span>
            </v-flex>
            <v-flex shrink ml-4 v-if="form.hasAgenda4_4_3 === '1'">
              <p>จำนวน {{ agenda4_4_3.length }} โครงการ</p>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex
              style="text-align: right"
              v-if="form.hasAgenda4_4_3 === '1'"
            >
              <v-btn color="#3E7662" dark @click="add('agenda4_4_3')">
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex ml-12 justify-start align-center d-flex>
              <v-radio-group hide-details v-model="form.hasAgenda4_4_3" row>
                <v-radio
                  color="#3E7662"
                  style="padding-right: 60px"
                  label="มี"
                  value="1"
                ></v-radio>
                <v-radio
                  @click.native="clearRadio('hasAgenda4_4_3')"
                  color="#3E7662"
                  label="ไม่มี"
                  value="0"
                ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <!-- 4.4.3 if = 1  -->
          <div v-if="form.hasAgenda4_4_3 === '1'">
            <v-card
              class="mx-12 mt-4"
              v-for="(terminate, terminateIndex) in agenda4_4_3"
              :key="'4_4_3' + terminateIndex"
            >
              <div class="text-end">
                <v-icon
                  :disabled="agenda4_4_3.length <= 1"
                  color="#CC3D45"
                  class="clear-card"
                  @click="remove(terminateIndex, 'agenda4_4_3')"
                >
                  clear
                </v-icon>
              </div>

              <v-layout px-12>
                <v-flex ml-12 class="justify-start align-center d-flex">
                </v-flex>
                <v-flex shrink mr-3 class="justify-end align-center d-flex">
                  <span style="color: #CC3D45;font-weight: bold"
                    >*ระบุหัวข้อการวิจัย</span
                  >
                </v-flex>
                <v-flex xs4 class="justify-end align-center d-flex">
                  <text-autocomplete
                    :disabled="terminate.has === '0'"
                    :items="terminateList"
                    hide-details
                    item-text="name"
                    item-value="id"
                    :model="terminate.researchID"
                    @update-data="
                      updateData4_4_3('researchID', terminateIndex, $event)
                    "
                  />
                </v-flex>
              </v-layout>

              <v-layout px-12 my-6>
                <v-spacer></v-spacer>
                <v-flex>
                  <v-layout>
                    <v-flex
                      xs4
                      pt-2
                      pr-4
                      style="text-align: left;"
                      class="justify-end d-flex"
                    >
                      <span style="font-weight: bold;font-size: 16px;"
                        >ไฟล์</span
                      >
                    </v-flex>
                    <v-flex>
                      <v-file-input
                        :disabled="terminate.has === '0'"
                        accept=".pdf"
                        prepend-icon=""
                        :ref="'terminateFile_' + terminateIndex"
                        :id="'terminateFile_' + terminateIndex"
                        :model="terminate.file"
                        outlined
                        dense
                        counter
                        placeholder="Choose file"
                        :background-color="
                          terminate.has === '0' ||
                          terminate.rfType === '' ||
                          terminate.rfType === 'undefined'
                            ? '#E9E9E9'
                            : '#FBF6F3'
                        "
                        color="#3E7662"
                        item-color="#3E7662"
                        @change="
                          onUploadFile('agenda4_4_3', terminateIndex, $event)
                        "
                        hide-details
                      >
                      </v-file-input>
                    </v-flex>
                    <v-flex shrink pl-4 style="text-align: left">
                      <v-btn
                        :disabled="terminate.has === '0'"
                        color="#3E7662"
                        :dark="terminate.has !== '0'"
                        @click="onHandleBtn('terminateFile_' + terminateIndex)"
                      >
                        <v-icon class="pr-3">cloud_download</v-icon>
                        <span>Upload</span>
                      </v-btn>
                    </v-flex>
                    <v-flex shrink pl-4 style="text-align: left">
                      <v-btn
                        v-if="terminate.filePath"
                        :href="terminate.filePath"
                        class="white--text ml-2"
                        color="#DE7133"
                        target="_blank"
                      >
                        <span class="text-capitalize">ดาวน์โหลด</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout mt-4 px-12>
                <v-flex>
                  <textarea-form
                    :disabled="terminate.has === '0'"
                    :background-color="
                      terminate.has === '0' ? '#E9E9E9' : '#FBF6F3'
                    "
                    :rows="7"
                    :model="terminate.description"
                    @update-data="
                      updateData4_4_3('description', terminateIndex, $event)
                    "
                  ></textarea-form>
                </v-flex>
              </v-layout>

              <v-layout px-12 pb-12 v-if="terminate.researchID">
                <v-flex shrink mr-3 class="justify-end align-center d-flex">
                  <span style="color: #CC3D45;font-weight: bold"
                    >ผู้รับผิดชอบ</span
                  >
                </v-flex>
                <v-flex xs4 class="justify-end align-center d-flex ">
                  <textfield-form
                    readonly
                    hide-detail
                    :model="terminate.reviewerName"
                  />
                </v-flex>
              </v-layout>
            </v-card>
          </div>

          <!--5 agenda-->
          <v-layout px-12 pt-12>
            <v-flex xs1 mb-2 style="text-align: left;">
              <span style="font-weight: bold;color: #3E7662">
                วาระที่ 5
              </span>
            </v-flex>
            <v-flex mb-2 style="text-align: left;">
              <span style="font-weight: bold;">
                เรื่องอื่นๆ
              </span>
            </v-flex>
            <v-flex
              shrink
              pt-2
              pr-4
              style="text-align: left;"
              class="justify-end d-flex"
            >
              <span style="font-weight: bold;font-size: 16px;">ไฟล์</span>
            </v-flex>
            <v-flex xs3>
              <v-file-input
                accept=".pdf"
                prepend-icon=""
                outlined
                id="fifthAgendaFile"
                dense
                placeholder="Choose file"
                color="#3E7662"
                item-color="#3E7662"
                hide-details
                @change="onUploadFile('fifthAgendaFile', 0, $event)"
              ></v-file-input>
            </v-flex>
            <v-flex shrink pl-4 style="text-align: left">
              <v-btn
                color="#3E7662"
                dark
                @click="onHandleBtn('fifthAgendaFile')"
              >
                <v-icon class="pr-3">cloud_download</v-icon>
                <span>Upload</span>
              </v-btn>
              <v-btn
                v-if="form.fifthAgendaFilePath"
                :href="form.fifthAgendaFilePath"
                class="white--text ml-2"
                color="#DE7133"
                target="_blank"
              >
                <span>ดาวน์โหลด</span>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout px-12 mt-4>
            <v-flex>
              <textarea-form
                :model="form.fifthAgenda"
                @update-data="updateData('fifthAgenda', $event)"
              ></textarea-form>
            </v-flex>
          </v-layout>
          <v-layout px-12>
            <v-radio-group row v-model="form.result5">
              <p class="meeting-result">มติที่ประชุม</p>
              <v-radio
                value="รับทราบ"
                label="รับทราบ"
                color="#3E7662"
              ></v-radio>
              <v-radio
                value="ไม่รับทราบ"
                label="ไม่รับทราบ"
                color="#3E7662"
              ></v-radio>
            </v-radio-group>
          </v-layout>

          <!--End Time-->
          <v-layout px-12>
            <v-flex
              shrink
              d-flex
              mr-2
              justify-start
              align-center
              style="color: black;font-weight: bold;"
            >
              <span><b>ปิดการประชุม เวลา</b></span>
            </v-flex>
            <v-flex shrink d-flex justify-start align-center>
              <vue-timepicker v-model="form.meetingEndTime"></vue-timepicker>
            </v-flex>
            <v-flex shrink d-flex align-center ml-2
              ><span><b>น.</b></span></v-flex
            >
          </v-layout>
          <v-layout mt-8 px-12>
            <v-flex
              shrink
              d-flex
              justify-start
              align-center
              style="text-align: left;font-weight: bold"
            >
              <span>ผลการพิจารณาโครงร่างการวิจัย</span>
            </v-flex>
          </v-layout>
          <v-layout px-12 mt-4>
            <v-flex
              d-flex
              justify-start
              align-center
              style="text-align: left;font-weight: bold"
            >
              <v-file-input
                prepend-icon=""
                hide-details
                label="กรุณาเลือกไฟล์ PDF"
                outlined
                dense
                color="#3E7662"
                clearable
                background-color="#FBF6F3"
                show-size
                append-icon="attach_file"
                @change="onUploadFile('result', 0, $event)"
              ></v-file-input>
            </v-flex>
          </v-layout>
          <v-layout style="padding-left: 100px;" mt-1 v-if="form.resultPath">
            <v-flex style="text-align: left;font-size: 14px">
              <span>ไฟล์: </span>
              <a style="color: #CC3D45" :href="form.resultPath">{{
                form.resultPath
              }}</a>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-divider
        class="mt-12"
        style="background-color: #544A44;border-width: 2px"
      ></v-divider>
    </v-card>

    <!-- Button -->
    <v-layout mt-12>
      <v-flex mr-8 d-flex justify-end>
        <v-btn color="#FFFFFF" @click="$router.push('/sub-meeting')">
          <span style="color: #3E7662;font-weight: bold">ย้อนกลับ</span>
        </v-btn>
      </v-flex>
      <v-flex mr-12 shrink d-flex justify-end>
        <v-btn color="#3E7662" dark @click="save">
          <span style="font-weight: bold">ยืนยันการบันทึก</span>
        </v-btn>
      </v-flex>
    </v-layout>
    <loading
      color="#527281"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="false"
    ></loading>
  </v-content>
</template>

<script>
import vSelect from "vue-select";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import Timeselector from "vue-timeselector";
import { mapState, mapActions } from "vuex";
import TextareaForm from "../../components/input/TextareaForm";
import DateInputForm from "../../components/input/DateInputForm";
import FileInputForm from "../../components/input/FileInputForm";
import TextfieldForm from "../../components/input/TextfieldForm";
import { VueEditor } from "vue2-editor";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextAutocomplete from "../../components/input/TextAutocomplete";

export default {
  name: "CreateSubMeeting",
  components: {
    TextareaForm,
    TextfieldForm,
    VueEditor,
    DateInputForm,
    Loading,
    FileInputForm,
    Timeselector,
    VueTimepicker,
    vSelect,
    TextAutocomplete,
  },
  computed: {
    years() {
      this.year = new Date().getFullYear();
      return Array.from(
        { length: this.year - 1900 },
        (value, index) => 1901 + 543 + index
      ).reverse();
    },
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  data: () => ({
    refreshIntervalID: null,
    isAutoSave: false,
    items: [
      { id: "correspondence", name: "Correspondence" },
      { id: "rf12", name: "Amendment Protocol" },
      { id: "rf04_2", name: "SAE Report" },
      { id: "rf04_1", name: "Adverse Drug Reaction Report" },
      { id: "rf05", name: "Deviation Report" },
    ],
    adverseItems: [
      { id: "rf04_2", name: "SAE Report" },
      { id: "rf04_1", name: "Adverse Drug Reaction Report" },
    ],
    isLoading: false,
    fullPage: true,
    form: {
      meetingName: "",
      meetingNumber: "",
      meetingYear: "",
      meetingDate: "",
      meetingTime: "",
      meetingPlace: "",
      firstAgenda: "",
      firstAgendaFile: "",
      secondAgenda: "",
      fifthAgenda: "",
      fifthAgendaFile: "",
      hasAgenda3: "0",
      hasAgenda4_1: "0",
      hasAgenda4_2_1: "0",
      hasAgenda4_2_2: "0",
      hasAgenda4_3: "0",
      hasAgenda4_4_1: "0",
      hasAgenda4_4_2: "0",
      hasAgenda4_4_3: "0",
      result: "",
      result1: "",
      result2: "",
      result3: "",
      result4_1: "",
      result4_2_1: "",
      result4_2_2: "",
      result4_3: "",
      result5: "",
      meetingEndTime: "",
    },
    reviewers: [
      {
        userID: "",
      },
    ],
    reviewersNotJoin: [
      {
        userID: "",
      },
    ],
    agenda4_4_1: [
      {
        researchID: "",
        description: "",
        reviewerID: "",
        isApprove: "",
        reviewerName: "",
        file: null,
      },
    ],
    agenda4_4_2: [
      {
        researchID: "",
        description: "",
        reviewerID: "",
        isApprove: "",
        reviewerName: "",
        file: null,
      },
    ],
    agenda4_4_3: [
      {
        researchID: "",
        description: "",
        reviewerID: "",
        isApprove: "",
        reviewerName: "",
        file: null,
      },
    ],
    agenda3: [
      {
        meetingID: "",
        document: [
          {
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
            rfType: "",
            reviewerName: "",
            file: null,
          },
        ],
      },
    ],
    agenda4_1: [
      {
        researchID: "",
        description: "",
        reviewers: [
          {
            userID: "",
            comment: "",
            file: "",
          },
        ],
        isApprove: "",
        file: null,
      },
    ],
    agenda4_2_1: [
      {
        researchID: "",
        description: "",
        reviewerID: "",
        isApprove: "",
        reviewerName: "",
        rfType: "",
        file: null,
      },
    ],
    agenda4_2_2: [
      {
        researchID: "",
        description: "",
        reviewerID: "",
        isApprove: "",
        reviewerName: "",
        rfType: "",
        file: null,
      },
    ],
    agenda4_3: [
      {
        researchID: "",
        description: "",
        reviewerID: "",
        isApprove: "",
        reviewerName: "",
        file: null,
      },
    ],
    meetingDate: "",
    researchConList: [],
    research4_2_1List: [],
    research4_2_2List: [],
    researchAmendmentsList: [],
    researchAdverseEventsList: [],
    researchAdverseDrugEventsList: [],
    researchDeviationsList: [],
    reviewerList: [],
    meetingList: [],
    progressList: [],
    terminateList: [],
    finalList: [],
    renderKey: 0,
  }),

  beforeDestroy() {
    if (this.refreshIntervalID) clearInterval(this.refreshIntervalID);
  },
  async created() {
    await this.getReviewerList();
    await this.getInitialResearch();
    await this.getMeetingList();
    await this.getSubMeet();
    await this.reRender();
  },

  methods: {
    async getSubMeet() {
      this.isLoading = true;
      const getSubMeet = await this.$store.dispatch(
        "Meeting/getSubMeet",
        this.$route.query.id
      );
      this.form.meetingName = getSubMeet.meetingName;
      this.form.meetingNumber = getSubMeet.meetingNumber;
      this.form.meetingYear = getSubMeet.meetingYear;
      this.form.meetingDate = getSubMeet.meetingDate;
      this.meetingDate = this.changeDate(getSubMeet.meetingDate);
      this.form.meetingTime = getSubMeet.meetingTime;
      this.form.meetingPlace = getSubMeet.meetingPlace;

      this.reviewers = getSubMeet.reviewers;
      this.reviewersNotJoin = getSubMeet.reviewersNotJoin;
      this.form.hasAgenda3 = getSubMeet.hasAgenda3;
      this.form.hasAgenda4_1 = getSubMeet.hasAgenda4_1;
      this.form.hasAgenda4_2_1 = getSubMeet.hasAgenda4_2_1;
      this.form.hasAgenda4_2_2 = getSubMeet.hasAgenda4_2_2;
      this.form.hasAgenda4_3 = getSubMeet.hasAgenda4_3;
      this.form.hasAgenda4_4_1 = getSubMeet.hasAgenda4_4_1;
      this.form.hasAgenda4_4_2 = getSubMeet.hasAgenda4_4_2;
      this.form.hasAgenda4_4_3 = getSubMeet.hasAgenda4_4_3;
      this.form.firstAgenda = getSubMeet.firstAgenda;
      this.form.firstAgendaFile = getSubMeet.firstAgendaFile;
      this.form.firstAgendaFilePath = getSubMeet.firstAgendaFilePath;
      this.form.secondAgenda = getSubMeet.secondAgenda;
      this.form.secondAgendaFile = getSubMeet.secondAgendaFile;
      this.form.secondAgendaFilePath = getSubMeet.secondAgendaFilePath;
      this.form.fifthAgenda = getSubMeet.fifthAgenda;
      this.form.fifthAgendaFile = getSubMeet.fifthAgendaFile;
      this.form.fifthAgendaFilePath = getSubMeet.fifthAgendaFilePath;
      this.form.result = getSubMeet.result;
      this.form.resultPath = getSubMeet.resultPath;
      this.form.result1 = getSubMeet.result1;
      this.form.result2 = getSubMeet.result2;
      this.form.result3 = getSubMeet.result3;
      this.form.result4_1 = getSubMeet.result4_1;
      this.form.result4_2_1 = getSubMeet.result4_2_1;
      this.form.result4_2_2 = getSubMeet.result4_2_2;
      this.form.result4_3 = getSubMeet.result4_3;
      this.form.result5 = getSubMeet.result5;
      this.form.meetingEndTime = getSubMeet.meetingEndTime;
      this.agenda3 = getSubMeet.agenda3;
      this.agenda4_1 = getSubMeet.agenda4_1;
      this.agenda4_2_1 = getSubMeet.agenda4_2_1;
      this.agenda4_2_2 = getSubMeet.agenda4_2_2;
      this.agenda4_4_1 = getSubMeet.agenda4_4_1;
      this.agenda4_4_2 = getSubMeet.agenda4_4_2;
      this.agenda4_4_3 = getSubMeet.agenda4_4_3;
      this.agenda4_3 = getSubMeet.agenda4_3;
      if (getSubMeet.agenda3)
        this.agenda3.forEach((third, index) => {
          third.document.forEach((data, i) => {
            if (typeof this.researchConList[index * 10 + i] == undefined) {
              console.log("no");
            }
            switch (data.rfType) {
              case "rf12":
                console.log("index", index);
                console.log("researchConList", this.researchConList[index]);
                this.researchConList[
                  index * 10 + i
                ] = this.researchAmendmentsList;
                // this.researchConList[index*10 + i]] = this.researchAmendmentsList;
                break;
              case "rf04_2":
                this.researchConList[
                  index * 10 + i
                ] = this.researchAdverseEventsList;
                break;
              case "rf04_1":
                this.researchConList[
                  index * 10 + i
                ] = this.researchAdverseDrugEventsList;
                break;
              case "rf05":
                this.researchConList[
                  index * 10 + i
                ] = this.researchDeviationsList;
                break;
            }
          });
        });
      if (getSubMeet.agenda4_2_1)
        this.agenda4_2_1.forEach((data, index) => {
          switch (data.rfType) {
            case "rf12":
              this.research4_2_1List[index] = this.researchAmendmentsList;
              // this.research4_2_1List[index][index] = this.researchAmendmentsList;
              break;
            case "rf04_2":
              this.research4_2_1List[index] = this.researchAdverseEventsList;
              break;
            case "rf04_1":
              this.research4_2_1List[
                index
              ] = this.researchAdverseDrugEventsList;
              break;
            case "rf05":
              this.research4_2_1List[index] = this.researchDeviationsList;
              break;
          }
        });
      if (getSubMeet.agenda4_2_2)
        this.agenda4_2_2.forEach((data, index) => {
          switch (data.rfType) {
            case "rf12":
              this.research4_2_2List[index] = this.researchAmendmentsList;
              // this.research4_2_2List[index][index] = this.researchAmendmentsList;
              break;
            case "rf04_2":
              this.research4_2_2List[index] = this.researchAdverseEventsList;
              break;
            case "rf04_1":
              this.research4_2_2List[
                index
              ] = this.researchAdverseDrugEventsList;
              break;
            case "rf05":
              this.research4_2_2List[index] = this.researchDeviationsList;
              break;
          }
        });

      this.isLoading = false;
    },
    reRender() {
      this.renderKey++;
      console.log("rerender", this.renderKey);
    },
    updateData(name, val, index = 0) {
      if (name === "reviewer") {
        this.reviewers[index].userID = val;
      } else {
        this.form[name] = val;
        if (name === "reviewersNotJoin") {
          this.reviewersNotJoin[index].userID = val;
        } else {
          this.form[name] = val;
        }
      }
    },
    updateDate(name, val) {
      if (name === "meetingDate") {
        this.form.meetingDate = val.date;
        this.meetingDate = this.changeDate(val.date);
      }
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);
      sub_year = parseInt(sub_year) + 543;
      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    updateData3(name, index, val, thirdIndex = 0) {
      if (name === "researchID") {
        let research = this.researchConList[thirdIndex * 10 + index].filter(
          (research) => research.id == val
        );
        this.agenda3[thirdIndex].document[index][name] = research[0].id;
        this.agenda3[thirdIndex].document[index]["reviewerID"] =
          research[0].reviewerID;
        this.agenda3[thirdIndex].document[index]["reviewerName"] =
          research[0].reviewerName;
      } else {
        this.agenda3[thirdIndex].document[index][name] = val;
      }
      switch (val) {
        case "rf12":
          this.researchConList[
            thirdIndex * 10 + index
          ] = this.researchAmendmentsList;
          this.agenda3[thirdIndex].document[index].researchID = "";
          break;
        case "rf04_2":
          this.researchConList[
            thirdIndex * 10 + index
          ] = this.researchAdverseEventsList;
          this.agenda3[thirdIndex].document[index].researchID = "";
          break;
        case "rf04_1":
          this.researchConList[
            thirdIndex * 10 + index
          ] = this.researchAdverseDrugEventsList;
          this.agenda3[thirdIndex].document[index].researchID = "";
          break;
        case "rf05":
          this.researchConList[
            thirdIndex * 10 + index
          ] = this.researchDeviationsList;
          this.agenda3[thirdIndex].document[index].researchID = "";
          break;
      }
      this.$forceUpdate();
    },
    updateData4_1(name, index, val) {
      if (name === "researchID") {
        let research = this.researchAmendmentsList.filter(
          (research) => research.id === val
        );
        this.agenda4_1[index][name] = research[0].id;
        this.agenda4_1[index]["reviewers"][0].userID = research[0].reviewerID;
        // this.agenda4_1[index]["reviewerName"] = research[0].reviewerName;
      } else {
        this.agenda4_1[index][name] = val;
      }
    },
    updateData4_2_1(name, index, val) {
      if (name === "researchID") {
        let research = this.research4_2_1List[index].filter(
          (research) => research.id === val
        );
        this.agenda4_2_1[index][name] = research[0].id;
        this.agenda4_2_1[index]["reviewerID"] = research[0].reviewerID;
        this.agenda4_2_1[index]["reviewerName"] = research[0].reviewerName;
      } else {
        this.agenda4_2_1[index][name] = val;
      }
      switch (val) {
        case "rf12":
          this.research4_2_1List[index] = this.researchAmendmentsList;
          this.agenda4_2_1[index].researchID = "";
          break;
        case "rf04_2":
          this.research4_2_1List[index] = this.researchAdverseEventsList;
          this.agenda4_2_1[index].researchID = "";
          break;
        case "rf04_1":
          this.research4_2_1List[index] = this.researchAdverseDrugEventsList;
          this.agenda4_2_1[index].researchID = "";
          break;
        case "rf05":
          this.research4_2_1List[index] = this.researchDeviationsList;
          this.agenda4_2_1[index].researchID = "";
          break;
      }
      this.$forceUpdate();
    },
    updateData4_2_2(name, index, val) {
      if (name === "researchID") {
        let research = this.research4_2_2List[index].filter(
          (research) => research.id === val
        );
        this.agenda4_2_2[index][name] = research[0].id;
        this.agenda4_2_2[index]["reviewerID"] = research[0].reviewerID;
        this.agenda4_2_2[index]["reviewerName"] = research[0].reviewerName;
      } else {
        this.agenda4_2_2[index][name] = val;
      }
      switch (val) {
        case "rf12":
          this.research4_2_2List[index] = this.researchAmendmentsList;
          this.agenda4_2_2[index].researchID = "";
          break;
        case "rf04_2":
          this.research4_2_2List[index] = this.researchAdverseEventsList;
          this.agenda4_2_2[index].researchID = "";
          break;
        case "rf04_1":
          this.research4_2_2List[index] = this.researchAdverseDrugEventsList;
          this.agenda4_2_2[index].researchID = "";
          break;
        case "rf05":
          this.research4_2_2List[index] = this.researchDeviationsList;
          this.agenda4_2_2[index].researchID = "";
          break;
      }
      this.$forceUpdate();
    },
    updateData4_3(name, index, val) {
      if (name === "researchID") {
        let research = this.researchDeviationsList.filter(
          (research) => research.id === val
        );
        this.agenda4_3[index][name] = research[0].id;
        this.agenda4_3[index]["reviewerID"] = research[0].reviewerID;
        this.agenda4_3[index]["reviewerName"] = research[0].reviewerName;
      } else {
        this.agenda4_3[index][name] = val;
      }
    },
    updateData4_4_1(name, index, val) {
      if (name === "researchID") {
        let research = this.progressList.filter(
          (research) => research.id === val
        );
        this.agenda4_4_1[index][name] = research[0].id;
        this.agenda4_4_1[index]["reviewerID"] = research[0].reviewerID;
        this.agenda4_4_1[index]["reviewerName"] = research[0].reviewerName;
      } else {
        this.agenda4_4_1[index][name] = val;
      }
    },
    updateData4_4_2(name, index, val) {
      if (name === "researchID") {
        let research = this.finalList.filter((research) => research.id === val);
        this.agenda4_4_2[index][name] = research[0].id;
        this.agenda4_4_2[index]["reviewerID"] = research[0].reviewerID;
        this.agenda4_4_2[index]["reviewerName"] = research[0].reviewerName;
      } else {
        this.agenda4_4_2[index][name] = val;
      }
    },
    updateData4_4_3(name, index, val) {
      if (name === "researchID") {
        let research = this.terminateList.filter(
          (research) => research.id === val
        );
        this.agenda4_4_3[index][name] = research[0].id;
        this.agenda4_4_3[index]["reviewerID"] = research[0].reviewerID;
        this.agenda4_4_3[index]["reviewerName"] = research[0].reviewerName;
      } else {
        this.agenda4_4_3[index][name] = val;
      }
    },
    getInitialResearch() {
      this.isLoading = true;
      this.$store
        .dispatch("Research/getInitialResearchList")
        .then((res) => {
          this.isLoading = false;
          console.log("getInitialResearchList", res);
          res.amendment.forEach((data) => {
            this.researchAmendmentsList.push({
              id: data.research.id,
              name:
                data.research.researchCode + "-" + data.research.thResearchName,
              reviewerID: data.reviewerID,
              reviewerName: data.reviewer.thName,
            });
          });
          res.adverseEvent.forEach((data) => {
            this.researchAdverseEventsList.push({
              id: data.research.id,
              name:
                data.research.researchCode + "-" + data.research.thResearchName,
              reviewerID: data.reviewerID,
              reviewerName: data.reviewer.thName,
            });
          });
          res.adverseDrugEvent.forEach((data) => {
            this.researchAdverseDrugEventsList.push({
              id: data.research.id,
              name:
                data.research.researchCode + "-" + data.research.thResearchName,
              reviewerID: data.reviewerID,
              reviewerName: data.reviewer.thName,
            });
          });
          res.deviation.forEach((data) => {
            this.researchDeviationsList.push({
              id: data.research.id,
              name:
                data.research.researchCode + "-" + data.research.thResearchName,
              reviewerID: data.reviewerID,
              reviewerName: data.reviewer.thName,
            });
          });
          res.final.forEach((data) => {
            this.finalList.push({
              id: data.research.id,
              name:
                data.research.researchCode + "-" + data.research.thResearchName,
              reviewerID: data.reviewerID,
              reviewerName: data.mainResearcher,
            });
          });
          res.progress.forEach((data) => {
            this.progressList.push({
              id: data.research.id,
              name:
                data.research.researchCode + "-" + data.research.thResearchName,
              reviewerID: data.reviewerID,
              reviewerName: data.firstName + " " + data.lastName,
            });
          });
          res.terminate.forEach((data) => {
            this.terminateList.push({
              id: data.research.id,
              name:
                data.research.researchCode + "-" + data.research.thResearchName,
              reviewerID: data.reviewerID,
              reviewerName: data.mainResearcher,
            });
          });
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    getMeetingList() {
      this.$store.dispatch("Meeting/getSubMeetList").then((res) => {
        res.forEach((data) => {
          this.meetingList.push({
            id: data.id,
            name: data.meetingName + " (" + data.meetingDate + ")",
          });
        });
      });
    },
    save(isSubmit = 0) {
      console.log("isSubmit", isSubmit);
      if (isSubmit) {
        this.isLoading = true;
        if (this.refreshIntervalID) clearInterval(this.refreshIntervalID);
      }
      this.form["agenda3"] = this.agenda3;
      this.form["agenda4_1"] = this.agenda4_1;
      this.form["agenda4_2_1"] = this.agenda4_2_1;
      this.form["agenda4_2_2"] = this.agenda4_2_2;
      this.form["agenda4_3"] = this.agenda4_3;
      this.form["agenda4_4_1"] = this.agenda4_4_1;
      this.form["agenda4_4_2"] = this.agenda4_4_2;
      this.form["agenda4_4_3"] = this.agenda4_4_3;
      this.form["reviewers"] = this.reviewers;
      this.form["reviewersNotJoin"] = this.reviewersNotJoin;
      this.form["isSubmit"] = isSubmit;
      this.form["id"] = this.$route.query.id;
      this.$store
        .dispatch("Meeting/updateSubMeet", this.form)
        .then((res) => {
          if (isSubmit) {
            Swal.fire({
              title: "บันทึกสำเร็จ",
              icon: "success",
              confirmButtonColor: "#3E7662",
            });
            this.isLoading = false;
            this.$router.push("/sub-meeting");
          } else this.form["id"] = res.id;
        })
        .catch((e) => {
          if (isSubmit) {
            this.isLoading = false;
            if (e.response.data.errors) {
              for (var k in e.response.data.errors) {
                Swal.fire({
                  title: "เกิดข้อผิดพลาด",
                  text: e.response.data.errors[k][0],
                  icon: "warning",
                  confirmButtonColor: "#3E7662",
                }).then(() => {
                  this.$vuetify.goTo(`#${k}`);
                });
              }
            }
          }
        });
    },
    toggleAutoSave() {
      if (this.isAutoSave) {
        //auto save every 10 sec
        this.refreshIntervalID = setInterval(this.save, 10000);
      } else {
        if (this.refreshIntervalID) {
          clearInterval(this.refreshIntervalID);
          this.refreshIntervalID = null;
        }
      }
    },
    clearRadio(name, index) {
      if (name === "hasAgenda3") {
        this.agenda3 = [
          {
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
            reviewerName: "",
            rfType: "",
            file: null,
          },
        ];
      }
      if (name === "hasAgenda4_1") {
        this.agenda4_1 = [
          {
            researchID: "",
            description: "",
            reviewers: [
              {
                userID: "",
                comment: "",
                file: "",
              },
            ],
            isApprove: "",
            file: null,
          },
        ];
      }
      if (name === "hasAgenda4_2_1") {
        this.agenda4_2_1 = [
          {
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
            reviewerName: "",
            rfType: "",
            file: null,
          },
        ];
      }
      if (name === "hasAgenda4_2_2") {
        this.agenda4_2_2 = [
          {
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
            reviewerName: "",
            rfType: "",
            file: null,
          },
        ];
      }
      if (name === "hasAgenda4_3") {
        this.agenda4_3[index].has = [
          {
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
            reviewerName: "",
            file: null,
          },
        ];
      }
      if (name === "hasAgenda4_4_1") {
        console.log("1");
        this.agenda4_4_1 = [
          {
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
            reviewerName: "",
            file: null,
          },
        ];
      }
      if (name === "hasAgenda4_4_2") {
        console.log("2");
        this.agenda4_4_2 = [
          {
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
            reviewerName: "",
            file: null,
          },
        ];
      }
      if (name === "hasAgenda4_4_3") {
        console.log("3");
        this.agenda4_4_3 = [
          {
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
            reviewerName: "",
            file: null,
          },
        ];
      }
    },
    add(name, index = 0) {
      switch (name) {
        case "agenda4_1":
          this.agenda4_1.push({
            researchID: "",
            description: "",
            reviewers: [
              {
                userID: "",
                comment: "",
                file: "",
              },
            ],
            isApprove: "",
            file: null,
          });
          break;
        case "agenda4_2_1":
          this.agenda4_2_1.push({
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
            rfType: "",
            file: null,
          });
          break;
        case "agenda4_2_2":
          this.agenda4_2_2.push({
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
            file: null,
            rfType: "",
          });
          break;
        case "agenda4_3":
          this.agenda4_3.push({
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
            file: null,
          });
          break;
        case "agenda4_4_1":
          this.agenda4_4_1.push({
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
            file: null,
          });
          break;
        case "agenda4_4_2":
          this.agenda4_4_2.push({
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
            file: null,
          });
          break;
        case "agenda4_4_3":
          this.agenda4_4_3.push({
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
            file: null,
          });
          break;
        case "agenda3":
          this.agenda3.push({
            meetingID: "",
            document: [
              {
                researchID: "",
                description: "",
                reviewerID: "",
                isApprove: "",
                rfType: "",
                reviewerName: "",
                file: null,
              },
            ],
          });
          break;
        case "doc3":
          console.log("index", this.agenda3);
          this.agenda3[index].document.push({
            researchID: "",
            description: "",
            reviewerID: "",
            isApprove: "",
            rfType: "",
            reviewerName: "",
            file: null,
          });
      }
    },
    remove(index, name, thirdIndex = 0) {
      console.log(index, name);
      switch (name) {
        case "agenda4_2_1":
          this.agenda4_2_1 = this.agenda4_2_1.filter((item, i) => i !== index);
          break;
        case "agenda4_1":
          this.agenda4_1 = this.agenda4_1.filter((item, i) => i !== index);
          break;
        case "agenda4_2_2":
          this.agenda4_2_2 = this.agenda4_2_2.filter((item, i) => i !== index);
          break;
        case "agenda4_3":
          this.agenda4_3 = this.agenda4_3.filter((item, i) => i !== index);
          break;
        case "agenda4_4_1":
          this.agenda4_4_1 = this.agenda4_4_1.filter((item, i) => i !== index);
          break;
        case "agenda4_4_2":
          this.agenda4_4_2 = this.agenda4_4_2.filter((item, i) => i !== index);
          break;
        case "agenda4_4_3":
          this.agenda4_4_3 = this.agenda4_4_3.filter((item, i) => i !== index);
          break;

        case "agenda3":
          this.agenda3 = this.agenda3.filter((item, i) => i !== index);
          break;
        case "doc3":
          this.agenda3[thirdIndex].document = this.agenda3[
            thirdIndex
          ].document.filter((item, i) => i !== index);
          break;
      }
    },
    addReviewer(name, index) {
      this[name].push({ userID: "" });
    },
    removeReviewer(name, index) {
      console.log(index);
      this[name] = this[name].filter((item, i) => i !== index);
      console.log(this.reviewers);
    },
    getReviewerList() {
      this.isLoading = true;
      this.$store
        .dispatch("User/getReviewerList")
        .then((res) => {
          this.isLoading = false;
          res.forEach((data) => {
            this.reviewerList.push({
              user_id: data.id,
              user_name: data.thName,
            });
          });
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    onUploadFile(val, index, e, thirdIndex = 0) {
      this.isLoading = true;
      if (val === "agenda3") {
        this.$store
          .dispatch("Common/onUploadFile", { name: val, file: e })
          .then((res) => {
            this[val][index].document[thirdIndex].file = res.fileName;
            this.isLoading = false;
          })
          .catch((error) => {
            this.isLoading = false;
            console.log(error);
          });
      } else if (
        val === "firstAgendaFile" ||
        val === "secondAgendaFile" ||
        val === "fifthAgendaFile" ||
        val === "result"
      ) {
        this.$store
          .dispatch("Common/onUploadFile", { name: val, file: e })
          .then((res) => {
            this.form[val] = res.fileName;
            this.isLoading = false;
          })
          .catch((error) => {
            this.isLoading = false;
            console.log(error);
          });
      } else {
        this.$store
          .dispatch("Common/onUploadFile", { name: val, file: e })
          .then((res) => {
            this[val][index].file = res.fileName;
            this.isLoading = false;
          })
          .catch((error) => {
            this.isLoading = false;
            console.log(error);
          });
      }

      this.isLoading = false;
    },
    onHandleBtn(index) {
      document.getElementById(index).click();
    },
  },
};
</script>

<style lang="scss">
.vue__time-picker input.display-time {
  background-color: #3e7662;
  color: white;
  border: 1px solid #d2d2d2;
  width: 10em;
  height: 2.2em;
  padding: 0.3em 0.5em;
  font-size: 1em;
}

.clear-card:hover {
  cursor: pointer;
  background-color: #f5a9a9;
}

.meeting-result {
  text-decoration: underline;
  margin-right: 16px;
  margin-top: 4px;
}
</style>
